<template>
  <basic-container>
    <div class="project-edit-container">
      <div class="inner-con">
        <div class="project-title">{{basicInfoData.name}}</div>
        <div class="project-status">
          <div class="status-title">审批状态</div>
          <!-- <div :class="['stateTopdiv', 'color_' + item.prop]"> -->
          <div class="status-content" :class="['stateTopdiv', 'color_' + basicInfoData.auditStatus]">
            {{basicInfoData.auditStatusStr}}
            <!-- {{ item.proptext ? item.proptext : item.prop }} -->
          </div>
        </div>
        <el-tabs v-model="activeName">
          <el-tab-pane class="activelabel" label="项目详情" name="first">
            <InfoContainer
              style="margin-top:20px;"
              :infoTitle="InfoContainerConfig['infoTitle']"
              :contentConfig="InfoContainerConfig['infoContent']"
            >
              <template slot="basicInfo">

                <avue-form
                  ref="basicInfo"
                  v-model="basicInfoData"
                  :option="formConfig"
                >
                  <template #name>
                    <!-- 存在绑定ID时不可更改项目 -->
                    <div class="project-name" @click="goProject">{{basicInfoData.name}}</div>
                  </template>
                  <!-- 债权人和债务人选择 -->
                  <template #sellerCustId>
                    <CommonSelect
                      bindLabel="custName"
                      bindKey="id"
                      bindValue="custName"
                      methods="get"
                      dataMethod="params"
                      dataUrl="bl/custbasicinformationbl/page"
                      :disabled="!isEditable"
                      :bindId="basicInfoData.sellerCustId?basicInfoData.sellerCustId:''"
                      @handleChange="setSellerCustId"
                    />
                  </template>
                  <template #buyerCustId>
                    <CommonSelect
                      bindLabel="custName"
                      bindKey="id"
                      bindValue="custName"
                      methods="get"
                      dataMethod="params"
                      dataUrl="bl/custbasicinformationbl/page"
                      :disabled="!isEditable"
                      :bindId="basicInfoData.buyerCustId?basicInfoData.buyerCustId:''"
                      @handleChange="setBuyerCustId"
                    />
                  </template>
                  <!-- 报价方案 -->
                  <template #quotaPlan>
                    <div class="plan-container">
                      <CommonSelect
                        style="width:87%;"
                        innerKey="id"
                        innerKeyName="编号"
                        bindLabel="name"
                        bindKey="id"
                        bindValue="name"
                        methods="get"
                        dataMethod="params"
                        dataUrl="/bl/blcontractrental/page"
                        searchKey="name"
                        :disabled="!isEditable"
                        :bindId="rentId?rentId:''"
                        @handleChange="setQuotaPlan"
                      />
                      <div class="detail-button" @click="showQuatoDetail"><i class="el-icon-video-play"></i>查看详情</div>
                    </div>
                  </template>
                </avue-form>

                <div class="dash-line" style="width:100%;height:1px; border-top: 1px dashed #ccc;margin-bottom: 20px;"></div>

                <CommonDetail 
                    :showNull="!customerDataReady"
                    :configArray="extraFormConfig"
                    :initValue="basicInfoData"
                />
              </template>

            </InfoContainer>

           
            <!-- 流程公共附件 -->
            <Accessory
              v-loading="!dataReady"
              element-loading-text="加载中"
              element-loading-spinner="el-icon-loading"
              element-loading-background="rgba(153, 153, 153, 0.8)"
              v-if="uploadPermissionNameOne && uploadPermissionNameTwo"
              :idname="uploadPermissionNameTwo"
              :fileMenuUrlname="uploadPermissionNameOne"
              :projectid="basicInfoData.projectInfoId?basicInfoData.projectInfoId:basicInfoData.id"
              :dynamicId="id"
              :upload="true"
              :permissionList="permissionList"
              :isPermission="true"
            />

             <!-- 流程设计相关组件相关数据存储在workflow.js中 -->
            <!-- 流程设计审批信息表单 -->
            <AuditInfo
              ref="auditInfo"
              style="margin-top: 20px;"
              v-loading="!dataReady"
              element-loading-text="加载中"
              element-loading-spinner="el-icon-loading"
              element-loading-background="rgba(153, 153, 153, 0.8)"
              v-if="isStartedProcess && auditFormData && auditFormData != {}"
              :formDetailData="auditFormData"
              :isEditable="processDetail.process?processDetail.process.isEditable:false"
              :status="(processDetail.process && processDetail.process.status)?processDetail.process.status: 'done'"
            />
            
            <!-- 会签意见区 -->
            <CommentStep
              v-loading="!dataReady"
              element-loading-text="加载中"
              element-loading-spinner="el-icon-loading"
              element-loading-background="rgba(153, 153, 153, 0.8)"
              v-if="commentList.length > 0"
              :commentList="commentList"
              :taskSaveData="taskSaveData"
              :taskNo="processDetail.process?Number(processDetail.process.taskNo): 0"
              :status="(processDetail.process && processDetail.process.status)?processDetail.process.status: 'done'"
            />
            <!-- 流程记录  -->
            <CommentTable
              v-loading="!dataReady"
              element-loading-text="加载中"
              element-loading-spinner="el-icon-loading"
              element-loading-background="rgba(153, 153, 153, 0.8)"
              v-if="flowData.length>0"
              :flowData="flowData"
            />

            <!-- 会签意见区 -->
            <InfoContainer
              v-if="!isStartedProcess"
              class="comment-container"
              style="margin-top:20px;"
              :infoTitle="commentBlockConfig['infoTitle']"
              :contentConfig="commentBlockConfig['infoContent']"
            >
              <template #comment>
                <CommentBlock
                  ref="commentBlock"
                  @fileChange="fileChange"
                  :id='id'
                />
              </template>
            </InfoContainer>

            <div class="bottom-block" style="width: 100%; height: 45px;"></div>
          </el-tab-pane>

          <el-tab-pane label="客户概况" name="second">
            <InfoContainer
                style="margin-top:20px;"
                :infoTitle="customerConfig['infoTitle']"
                :contentConfig="customerConfig['infoContent']"
            >
                <template #customerInfo>
                    <CommonDetail 
                        :showNull="!customerDataReady"
                        :configArray="customerInfoConfig"
                        :initValue="customerDetail"
                    />
                </template>
            </InfoContainer>
          </el-tab-pane>

          <!-- <el-tab-pane label="报价方案" name="third">
            <QuotaComponent :readOnly="true" :bjId="basicInfoData.blContractRentalId" @dataInfo="concateData" style="margin-top:20px;"/>
          </el-tab-pane> -->

          <!-- 流程图（启动流程后显示） -->
          <el-tab-pane label="流程跟踪" name="fourth" v-if="isStartedProcess">
            <template v-if="activeName == 'fourth'">
              <el-card shadow="never" style="margin-top: 5px;">
                <wf-design ref="bpmn" style="height: 500px;" :options="bpmnOption"></wf-design>
              </el-card>
            </template>
          </el-tab-pane>

        </el-tabs>
      </div>
    </div>

    <!-- 底部按钮 -->
    <!-- 1.流程状态为todo时 2.提交状态为未提交可编辑时显示底部操作按钮-->
    <BottomLine
      ref="bottomLine"
      :auditState="basicInfoData.auditStatus"
      :processDetail="processDetail"
      :isStartedProcess="isStartedProcess"
      :buildNew="buildNew"
      @buildNewOne="buildNewOne"
      @startProcess="saveProject('startProcess')"
      @saveTask="saveTask"
      @saveProject="saveProject"
      @flowNext="flowNext"
      @openPrintForm="goPrint"
      @refreshData="refreshData"
    />

    <el-dialog
      :close-on-click-modal="false"
      title="报价方案"
      :visible.sync="quotaVisible"
      :modal-append-to-body="false"
      width="85%"
    >
      <QuotaComponent
        :readOnly="true"
        :bjId="basicInfoData.blContractRentalId"
        @dataInfo="concateData"
        style="margin-top:20px;"
      />
    </el-dialog>
    
  </basic-container>
</template>
<script>
import {getFactoringDetail, addFactoring, getPocessName} from '@/api/factoring/factoring'
import {getCustomerDetail} from '@/api/factoring/factoringCustomer'
import { getQuotaDetail } from "@/api/factoring/factoringScheme";
import InfoContainer from "@/components/infoContainer/infoContainer";
import { factoringAddFormConfig, buildProjectConfig, customerConfig, extraForm } from "./formConfig";
import { mapGetters } from "vuex";
import CommonDetail from "@/components/commonDetail/commonDetail"
// 报价方案组件
import QuotaComponent from "../quotaScheme/addEdit" 
// 工作流相关组件
import Accessory from "@/components/accessoriesother/accessoryFactor"
import AuditInfo from "@/components/workflowComponents/auditInfo/auditInfo"
import CommonSelect from "@/components/commonSelect/commonSelect"
import CommentStep from "@/components/workflowComponents/commentStep/commentStep"
import CommentTable from "@/components/workflowComponents/commentTable/commentTable"
import CommentBlock from "@/components/workflowComponents/commentBlock/commentBlock";
import BottomLine from "@/components/workflowComponents/bottomLine/bottomLine"
// import PrintDialog from "@/components/workflowComponents/printForm/printForm"
import { floatMul } from "@/util/util";
import workFlow from '@/mixins/workFlow'
import util from "@/mixins/util"
export default {
  name: 'EditFactoringProject',
  mixins: [workFlow, util],
  data() {
    return {
      rentId: '',
      quotaVisible: false,
      buildNew: false,
      customerDataReady: false,
      customerDetail: {},
      buildProjectConfig: buildProjectConfig(),
      customerInfoConfig: customerConfig(),
      extraFormConfig: extraForm(),
      projectData: {},
      // dataReady: false,
      processKey: 'rzzl_if_projectstart',
      detailFormUrl: '/factoring/buildProject/projectDetail',
      id: '',
      // 打印跳转链接Key
      key: '689729973394165760',
      attchmentList: [],
      // 是否开启流程, 根据是否已经绑定flowableId判断
      isStartedProcess: false,

      isEditable: true,
      basicInfoData: {
        projectInfoId:'',
        id:''
      },
      activeName: 'first',
      formConfig: factoringAddFormConfig(),
      InfoContainerConfig: {
        infoTitle: '基本信息',
        infoContent: [{
          title: '项目初步方案',
          prop: 'basicInfo'
        }]
      },
      customerConfig: {
          infoTitle: '客户信息',
          infoContent: [{
              title: '',
              prop: 'customerInfo'
          }]
      },      
    }
  },
  watch: {
    '$route.prams.id': {
      async handler(val) {
        if(val == 0){
          this.id = await this.getVirtualID()
          this.basicInfoData = JSON.parse(window.sessionStorage.getItem('buildProjectInfo'))
          // this.basicInfoData = JSON.parse(this.$route.query.projectData)
          this.buildNew = true
          this.setProjectData()
          this.queryCustomerDetail(this.basicInfoData)
          if(this.basicInfoData.blContractRentalId && this.basicInfoData.blContractRentalId != '-1'){
              this.queryQuota(this.basicInfoData.blContractRentalId)
          }          
        }else{
          this.id = val
          this.getFactoringDetail(this.id)          
        }

      }
    }
  },
  components: {
    InfoContainer,
    Accessory,
    AuditInfo,
    CommentStep,
    CommentTable,
    BottomLine,
    CommonSelect,
    CommentBlock,
    CommonDetail,
    QuotaComponent
    // PrintDialog
  },
  computed: {
    ...mapGetters(["workFlowData", "tag","userInfo"]),
  },
  async mounted() {
    this.id = this.$route.params.id
    if(this.id == 0){
      // 新建立项
      this.id = await this.getVirtualID()
      this.basicInfoData = JSON.parse(window.sessionStorage.getItem('buildProjectInfo'))
      // this.basicInfoData = JSON.parse(this.$route.query.projectData)
      this.buildNew = true
      this.setProjectData()
      this.queryCustomerDetail(this.basicInfoData)
      if(this.basicInfoData.blContractRentalId && this.basicInfoData.blContractRentalId != '-1'){
          this.queryQuota(this.basicInfoData.blContractRentalId)
      }      
    }else {
      this.queryFactoringDetail(this.id)
    }
    
  },
  methods: {
    showQuatoDetail() {
      this.quotaVisible = true
    },

    setQuotaPlan(data) {
      if(JSON.stringify(data) != {}) {
        this.queryQuota(data.id)
      }
    },
    concateData(data) {
      let newData = {}
      let self = this
      
      newData.quotaPlan = data.id
      // 20230227 还款方式数据取报价方案
      newData.repaymentType = `${data.repaymentFrequency}`
      // 年租息率
      newData.annualInterestRateStr = `${floatMul(Number(data.annualInterestRate),100)}`
      newData.blContractRentalId = data.id
      newData.factoringCredit = data.quotationPrice?`${Number(data.quotationPrice).toFixed(2)}`: '0'
      newData.factoringCreditStr = data.quotationPrice?`${this.getMoney(Number(data.quotationPrice))}`: '0'
      newData.financingMaturity = data.leaseTerm?data.leaseTerm: '0'

      newData.gracePeriod = data.gracePeriodDay && data.gracePeriodDay != '-1'?`${data.gracePeriodDay}天`: ''
      newData.graceRateStr = data.graceInterestRate && Number(data.graceInterestRate) != -1?`${(Number(data.graceInterestRate)*100).toFixed(2)}%`:''
      // 手续费
      let poundageData = data.outlays.length>0?data.outlays.filter(item => {return item.dictMainOutlayType == 1}):[]
      newData.poundage = poundageData.length>0?`${Number(poundageData[0].outlayAmount).toFixed(2)}`: '0'
      newData.poundageStr = poundageData.length>0?`${this.getMoney(Number(poundageData[0].outlayAmount))}`: '0'
      newData.poundageChargeType = poundageData.length>0?poundageData[0].outlayWay: ''
      // 保证金
      let casData = data.outlays.length>0?data.outlays.filter(item => {return item.dictMainOutlayType == 2}):[]
      newData.cashDeposit = casData.length>0?`${Number(casData[0].outlayAmount).toFixed(2)}`: '0'
      newData.cashDepositStr = casData.length>0?`${this.getMoney(Number(casData[0].outlayAmount))}`: '0'
      newData.cashDepositChargeType = casData.length>0?casData[0].outlayWay: ''
      newData.cashDepositReturnType = casData.length>0?`${casData[0].expirationTreatment}`: ''

      newData.overdueInterestRateStr = data.overdueInterestRate && Number(data.overdueInterestRate) != -1 ?(Number(data.overdueInterestRate)*100).toFixed(2):'0'
      newData.downParment = data.downPayment?data.downPayment: '0'
      newData.downParmentStr = data.downPayment?data.downPayment.split(',')[1]: '0'
      newData.downParmentUsageRate = data.downParmentUsageRate?data.downParmentUsageRate: '0'
      newData.xirr = data.xirr?data.xirr: '0'
      newData.xirrStr = data.xirr?`${(Number(data.xirr)*100).toFixed(4)}`: '0'

      let asyncOne = this.queryDict(newData.poundageChargeType, '/api/blade-system/dict-biz/dictionary?code=fee_collection_method')
      let asyncTwo = this.queryDict(newData.cashDepositChargeType, '/api/blade-system/dict-biz/dictionary?code=fee_collection_method')
      let asyncThree = this.queryDict(newData.cashDepositReturnType, '/api/blade-system/dict-biz/dictionary?code=expiration_treatment')
      Promise.all([asyncOne,asyncTwo, asyncThree]).then(res => {
          newData.poundageChargeTypeStr = res[0]
          newData.cashDepositChargeTypeStr = res[1]
          newData.cashDepositReturnTypeStr = res[2]
          self.basicInfoData = Object.assign({}, self.basicInfoData, newData)
      })

    },

    buildNewOne() {
      this.saveProject()
    },

    // 新增 设置参数
    setProjectData() {
      this.basicInfoData.auditStatusStr = '未提交'
      // basicInfoData中ID为带入项目ID
      this.basicInfoData.projectInfoId = this.basicInfoData.id
      this.basicInfoData.projectType = this.basicInfoData.projectType?`${this.basicInfoData.projectType}`:''
      this.basicInfoData.projectComeFrom = this.basicInfoData.projectComeFrom?`${this.basicInfoData.projectComeFrom}`:''
      this.basicInfoData.guaranteeMethod = this.basicInfoData.guaranteeMethod?`${this.basicInfoData.guaranteeMethod}`:''
    },

    goProject() {
      this.$router.push({
        path: `/factoring/projectManage/projectDetail/${this.basicInfoData.projectInfoId}`,
      })
    },
    goPrint() {
      this.openPrintForm(this.key, this.id)
    },
    refreshData() {
      this.queryFactoringDetail(this.id)
    },

    fileChange(fileList) {
      let self = this
      if(fileList.length > 0) {
        this.attchmentList = []
        fileList.map(item => {
          self.attchmentList.push({
            name: item.name,
            url: item.response.data.link
          })
        })
      }
    },

    async startProcess() {
      let redirectInfo ={
        url: this.detailFormUrl,
        id: this.id
      }
      let processNameRes = await getPocessName(this.basicInfoData) 
      let params = {
        detailFormUrl:  JSON.stringify(redirectInfo),
        processId: this.processDefinedId,
        comment: this.$refs.commentBlock.$data.opinionContent,
        attachmentList: this.attchmentList,
        processInstanceName: processNameRes.data.data.processInstanceName
      }
      let processInsId = await this.startWorkFlowProcess(params)
      this.basicInfoData.flowableId = processInsId
      this.submitForm()
    },

    setSellerCustId(data) {
      this.basicInfoData.sellerCustId = data.id
      this.basicInfoData.sellerCustName = data.custName
    },
    
    setBuyerCustId(data) {
      this.basicInfoData.buyerCustId = data.id
      this.basicInfoData.buyerCustName = data.custName
    },

    // 查询项目详情
    async queryFactoringDetail(id) {
      let res = await getFactoringDetail({id: id})
      if(res.data.code == 200){
        // 设置流程状态
        this.basicInfoData = res.data.data
        // 处理表单数据
        this.basicInfoData.projectType = this.basicInfoData.projectType?`${this.basicInfoData.projectType}`:this.basicInfoData.projectType
        this.basicInfoData.poundageChargeType = this.basicInfoData.poundageChargeType?`${this.basicInfoData.poundageChargeType}`:this.basicInfoData.poundageChargeType
        this.basicInfoData.cashDepositChargeType = this.basicInfoData.cashDepositChargeType?`${this.basicInfoData.cashDepositChargeType}`:this.basicInfoData.cashDepositChargeType
        this.basicInfoData.cashDepositReturnType = this.basicInfoData.cashDepositReturnType?`${this.basicInfoData.cashDepositReturnType}`:this.basicInfoData.cashDepositReturnType
        this.basicInfoData.marginReturnType = this.basicInfoData.marginReturnType?`${this.basicInfoData.marginReturnType}`:this.basicInfoData.marginReturnType
        this.basicInfoData.guaranteeMethod = this.basicInfoData.guaranteeMethod?`${this.basicInfoData.guaranteeMethod}`:this.basicInfoData.guaranteeMethod
        this.basicInfoData.projectComeFrom = this.basicInfoData.projectComeFrom?`${this.basicInfoData.projectComeFrom}`:this.basicInfoData.projectComeFrom

        this.basicInfoData.factoringCredit = this.basicInfoData.factoringCredit == '-1'?0:`${Number(this.basicInfoData.factoringCredit).toFixed(2)}`

        // 查询客户详情
        this.queryCustomerDetail(this.basicInfoData)
        // 查询报价方案
        this.rentId = this.basicInfoData.blContractRentalId
        // this.queryQuota(this.basicInfoData.blContractRentalId)

        // 查询流程数据
        this.$store.commit('SET_WORKFLOW_STATE', {state: this.basicInfoData.auditStatus})
        if(res.data.data && res.data.data.flowableId) {
          this.isStartedProcess = true
          // 集成在workFlow.js中
          await this.queryFlowData(res.data.data.flowableId)
        } else {
          // 未启动流程 查询第一个节点的文件上传权限
          this.processDefinedId = await this.userQueryProcessDefinedId(this.processKey)
          this.permissionList = await this.queryTaskUploadDetail(this.processDefinedId, '', true)
          // 设置流程表单路径
          this.queryProcessFormDetail(this.processDefinedId)
        }

        // 判断页面是否可编辑（1.流程未提交 2.流程详情中isEditable为true可编辑 3.当前为第一步时）
        let presentFlow = this.flowData[this.flowData.length - 1]
        if(this.basicInfoData.auditStatus == 0 || this.processDetail.flow[2].historyActivityId == presentFlow.historyActivityId) {
          this.columnEditChange(true)
        } else {
          this.columnEditChange(false)
        }
      } else {
        this.$message.error(res.data.message)
      }
    },

    async queryCustomerDetail(data) {
        let res = await getCustomerDetail({id: data.sellerCustId})
        if(res.data.code == 200){
            let list = [
                { code: "cust_type_rzzl", name: "custType" },
                { code: "bl_cust_attribute", name: "custAttribute" },
                { code: "enterprise_type", name: "enterpriseType" },
                { code: "enterprise_scale", name: "enterpriseScale" },
                { code: "cust_source", name: 'custSource'},
                { code: "cust_category", name: "custCategory"}                   
            ]
            let returnData = await this.dictionaryMap(list, res.data.data)

            this.customerDetail = {
              ...returnData
            }

            this.$set(this.customerDetail, 'custCompanyState', data.custCompanyState)
            this.$set(this.customerDetail, 'custProductSalesState', data.custProductSalesState)
            this.$set(this.customerDetail, 'custPropertyState', data.custPropertyState)
            this.$set(this.customerDetail, 'custOther', data.custOther)

            this.basicInfoData.industry = this.customerDetail.industryStr
            this.customerDataReady = true
            
            if(!this.basicInfoData.flowableId ){
               this.getBasicConfigData()
            }
            
        }
    },

    async getBasicConfigData() {
      this.processDefinedId = await this.userQueryProcessDefinedId(this.processKey)
      // 获取当前流程文件上传列表权限 permissionList
      this.permissionList = await this.queryTaskUploadDetail(this.processDefinedId, '', true)
      // 设置流程表单路径
      this.queryProcessFormDetail(this.processDefinedId)
    },


    async queryQuota(id) {
      if(id !== '' && id != -1){
        let res = await getQuotaDetail({id: id})
        if(res.data.code == 200){
          this.concateData(res.data.data, true)
        }
      }else{
        this.$message({
          message: '该项目尚未绑定报价方案',
          type: 'warning'
        })
      }
    },

    /**
     * @param {Boolean} edit 是否可编辑
     */
    columnEditChange(edit) {
      if(this.userInfo.user_id != this.basicInfoData.managerUser) edit = false
      this.isEditable = edit
      this.formConfig.column.map(item => {
        if(item.prop == 'sellerCustId') {
          return
        }
        if(!item.alwaysDisabled){
          if(item.prop == 'name') {
            item.disabled = true
            item.formslot = true
          }else {
            item.disabled = !edit
            // item.formslot = false
          }
        }

      })

      this.customerInfoConfig.map(item => {
        item.disabled = !edit
      })
    },

    // 保存流程
    async saveTask() {
      let taskId = this.processDetail.process.taskId
      // 从vuex中获取
      let comment = this.workFlowData.opinionContent
      // let attachmentList = this.workFlowData.attchmentList

      // 流程表单数据
      let customData = this.$refs.auditInfo.commentDetail
      let formData = this.$refs.auditInfo.$data.formData

      let variables = this.dealAuditForm(formData, customData)
      // 保存数据存储在variables中
      variables[`comment_${taskId}`] = comment
      // variables[`attachment_${taskId}`] = attachmentList

      let saveRes = await this.flowSaveTask(variables)
      // 刷新数据
      this.saveTask = {
        comment: '',
        attachment: []       
      }
      this.queryFactoringDetail(this.id)
      this.$forceUpdate()

    },

    // 流程流转
    async flowNext(taskInfoList) {
      let passType = await this.validForm();

      if (!passType) {
        return;
      }

      let presentFlow = this.flowData[this.flowData.length - 1];
      if (
        this.processDetail.flow[2].historyActivityId ==
        presentFlow.historyActivityId
      ) {
        this.submitForm();
      }


      let processInsId = this.processDetail.process.processInstanceId
      let taskId = this.processDetail.process.taskId
      let taskName = this.processDetail.process.taskName

      // 流程表单数据
      let valid = this.$refs.auditInfo.validData()
      if(valid){
        let customData = this.$refs.auditInfo.commentDetail
        let formData = this.$refs.auditInfo.$data.formData

        let variables = this.dealAuditForm(formData, customData)
        if(taskInfoList){
          await this.selectPeopleFlowNext(
            taskId,
            taskName,
            this.workFlowData.attchmentList?this.workFlowData.attchmentList:[],
            this.workFlowData.opinionContent?this.workFlowData.opinionContent:'',
            variables,
            JSON.stringify(taskInfoList),
          )
          
        }else {
          await this.taskFlowNext(
            taskId,
            processInsId,
            this.workFlowData.attchmentList?this.workFlowData.attchmentList:[],
            this.workFlowData.opinionContent?this.workFlowData.opinionContent:'',
            variables
          )
        }

        // 刷新数据
        this.queryFactoringDetail(this.id)
        this.$forceUpdate()
      }
    },
    validForm() {
      let self = this;
      return new Promise((resolve, reject) => {
        this.$refs.basicInfo.validate((valid, done) => {
                if (valid) {
                    done();
                    resolve(true);
                 
                }else {
                    self.$message({
                        type: "warning",
                        message: "请补全表单后提交",
                    });
                    }
                
            })
       
      });
    },
    saveProject(startProcess) {
      let self = this
      if((this.basicInfoData.managerUser == this.userInfo.user_id || this.basicInfoData.assistUser == this.userInfo.user_id) || this.buildNew ) {
        // 验证数据是否完全
        this.$refs.basicInfo.validate((valid, done) => {
          if(valid) {
            // 校验通过, 提交数据
            if(startProcess && startProcess == 'startProcess'){
              self.startProcess()
            }else{
              self.submitForm()
            }
            done()
          }else{
            this.activeName = 'first'
            self.$message({
              type: 'warning',
              message: '请补全基础信息数据后继续保存项目'
            })
          }
        })
      } else {
        this.$message.warning('您非该立项创建者或协办者暂无权限进行次操作')
      }
    },

    async submitForm() {
      let msg = this.$route.params.id == 0?'新建成功':'修改成功'
      if(!this.basicInfoData.blContractRentalId || this.basicInfoData.blContractRentalId == ''){
          this.$message({
            message: '请选择报价方案后再保存项目',
            type: 'warning'
          })
          return false
      }
      let params = {
        ...this.basicInfoData,
        accountingEntity: 1,
      }
      params.id = this.id
      // 新增客户详情数据
      params.custCompanyState = this.customerDetail.custCompanyState?this.customerDetail.custCompanyState: ''
      params.custProductSalesState = this.customerDetail.custProductSalesState?this.customerDetail.custProductSalesState: ''
      params.custPropertyState = this.customerDetail.custPropertyState?this.customerDetail.custPropertyState: ''
      params.custOther = this.customerDetail.custOther?this.customerDetail.custOther: ''

      let res = await addFactoring(params)
      if(res.data.code == 200){
        this.buildNew = false
         this.queryFactoringDetail(this.id)
        // 如果新增 关闭当前页面
        if(this.$route.params.id == 0){
          window.sessionStorage.removeItem('buildProjectInfo')
          this.$store.commit("DEL_TAG", this.tag);
          this.$router.push(`/factoring/buildProject/projectDetail/${this.id}`)
        }
        this.$message({
          message: msg,
          type: 'success'
        })
      }
    }
    
  }
}
</script>
<style lang="scss" scoped>
.project-edit-container{
  background-color: #fff;
  overflow: hidden auto;
  padding: 15px !important;
  padding-bottom: 30px !important;
  .plan-container{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    i{
      margin-right: 5px;
      font-size: 14px;
    }
    .detail-button{
      font-size: 12px;
      color: #19BE6B;
      cursor: pointer;
      margin-left: 15px;
    }
  }
  .inner-con{
    min-width: 1000px;
    max-width: 1100px;
    margin: 0 auto;
    margin-top: 3px;
    .project-name{
      // overflow: hidden;
      // white-space: nowrap;
      // text-overflow: ellipsis;
    }
    .project-name:hover{
      color: #409EFF;
      cursor: pointer;
    }
    .project-title{
      color: #333;
      font-size: 18px;
      font-weight: bold;
    }
    .project-status{
      .status-title{
        text-align: right;
        font-family: '微软雅黑', sans-serif;
        font-weight: 400;
        color: #999999;
        font-size: 14px;
      }
      .status-content{
        text-align: right;
        font-family: '微软雅黑', sans-serif;
        font-weight: 400;
        color: #666666;
        font-size: 20px;
      }
    }
  }
  .comment-container{
    margin-top: 20px;
    /deep/.detail-one{
      padding-top: 0 !important;
      padding-bottom: 0 !important;
    }
    /deep/.comment-container{
      margin-top: 0 !important;
    }
  }
  .stateTopdiv::before {
    content: "";
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    margin-right: 5px;
  }
  .color_0::before {
    background: #fec03d;
  }
  .color_1::before {
    background: #409eff;
  }
  .color_2::before {
    background: #51d351;
  }
  .color_3::before {
    background: #F56C6C;
  }
  .color_4::before {
    background: #F56C6C;
  }
}
/deep/.el-tabs__item {
  font-size: 18px ;
  font-weight: bolder ;
  margin-bottom: 10px ;
}
/deep/.el-tabs__item.is-active {
  background: none;
}
/deep/.el-tabs__header {
  margin: 0px;
}
</style>